/**
 * Utility functions for work order operations
 */

import { WorkOrder, WorkOrderStatus } from '../types/workOrders';

/**
 * Check if a work order is overdue
 * A work order is overdue if it has a due date, is still open, and the due date has passed
 *
 * @param workOrder - The work order to check
 * @returns true if the work order is overdue
 */
export function isWorkOrderOverdue(workOrder: Pick<WorkOrder, 'dueDate' | 'status'>): boolean {
    if (!workOrder.dueDate || workOrder.status !== WorkOrderStatus.OPEN) {
        return false;
    }
    const dueDate = new Date(workOrder.dueDate.replace(' ', 'T'));
    return dueDate < new Date();
}
